import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

import { pCtCiaCameraUpdate, pCtCiaCameraInfo } from "../../../service/400/P421Service";
import { genContractorList } from "../../../service/GEN/GenService";
import classNames from "classnames";
import { validateInputText } from "../../../utilities/ValidateUtil";


const init = {
    cameraId: "",
    cameraName: "",
    contractorCode: "",
    createdBy: "",
    seqPk: "",
};

export default function P421({ dialog, setDialog, onGetDataList, submitForm, setSubmitted, submitted, setKeyDown, keyDown }) {
    const [errData, setErrData] = useState(null);
    const [loading, setLoading] = useState(false);



    const [data, setData] = useState({ ...init });
    

    const [contractorList, setContractorList] = useState([]);




    const onInputTextChange = (e, key) => {
        let val = (e.target && e.target.value) || "";
        const id = key && key !== "" ? key : (e.target && e.target.id) || "";
        setData({
            ...data,
            [`${id}`]: val,
        });

        setKeyDown({
            ...keyDown,
            [`${id}`]: true,
        });
    };

    useEffect(() => {
        onContractorList(dialog);

        if (dialog.action === "U") {
            onP402GetDataInfo(dialog);
        }
    }, []);

    const handlerCloseDialog = () => {
        setDialog({ ...dialog, open: false, action: "", dataSet: null });
    };

    const onHide = () => {
        handlerCloseDialog();
        setData({});
    };

    const onP402GetDataInfo = async (data) => {
        setLoading(true);
        let req = {
            cameraId: data.dataSet.cameraId,
            userId: data.userId,
        };
        await pCtCiaCameraInfo(req).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    if (temp.length > 0) {
                        setData(temp[0]);
                    }
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onContractorList = async (data) => {
        let req = {
            userId: data.userId,
        };

        await genContractorList(req).then(
            (res) => {
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setContractorList(temp);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };



    const renderFooter = () => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(data)} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
            </div>
        );
    };

    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />
            <Dialog 
            header="กล้อง CIA" 
            visible={dialog.open} 
            style={{ width: "50vw" }} 
            footer={renderFooter()} 
            onHide={() => onHide()} 
            blockScroll={true} 
            className="p-fluid" 
            maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>รหัสกล้อง</label>
                        {dialog.action === "A" ? <span style={{ color: "red" }}>*</span> : ""}
                        <div className="p-inputgroup">
                            <InputText id="cameraId" placeholder="รหัสกล้อง" disabled={dialog.action === "U"} className={classNames({ "p-invalid": !(dialog.action === "U") })} type="text" maxLength="20" onChange={(e) => onInputTextChange(e, "cameraId")} value={data.cameraId} />
                        </div>
                        {submitted && !data.cameraId && validateInputText("cameraId", "รหัสกล้อง")}
                    </div>
                    <div className="p-col-12">
                        <label>ชื่อกล้อง</label>
                        <div className="p-inputgroup">
                            <InputText id="cameraName" placeholder="ชื่อกล้อง" type="text" maxLength="20" onChange={(e) => onInputTextChange(e, "cameraName")} value={data.cameraName} />
                        </div>
                    </div>
                    <div className="p-col-12">
                        <label>บริษัท</label>
                        <div className="p-inputgroup">
                            <Dropdown id="contractorCode" value={data.contractorCode} onChange={(e) => onInputTextChange(e, "contractorCode")} options={contractorList} optionLabel="contractorName" optionValue="contractorCode" placeholder="เลือก บริษัท" />
                        </div>
                    </div>
                    <div className="p-col-12">
                        <label>สร้างรายการโดย</label>
                        <div className="p-inputgroup">
                            <InputText id="createdBy" placeholder="สร้างรายการโดย" type="text" maxLength="20" onChange={(e) => onInputTextChange(e, "createdBy")} value={data.createdBy} disabled />
                        </div>
                    </div>
                </div>
            </Dialog>
            
        </>
    );
}
